import React from 'react'
import styles from './LabelPicker.module.scss';
import Select from 'react-select';

const CustomOption = ({innerRef, innerProps, isDisabled, data}) => {
    if (isDisabled) {
        return null;
    } else {
        return <div className={styles.customOption} ref={innerRef} {...innerProps}>
            <div className={styles.customOptionLabelDisplay} id={data.id} style={{borderColor: data.color}}>{data.name}</div>
        </div>;
    }
}

export const LabelPicker = ({labels, onChange, placeholder}) => {
    return (
        <Select
            isMulti
            placeholder={placeholder}
            options={labels}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            classNamePrefix={'styles'}
            noOptionsMessage={() => 'No labels found'}
            onChange={onChange}
            components={{
                Option: CustomOption,
            }}
            styles={{
                container: (baseStyles, state) => ({
                    ...baseStyles,
                    marginBottom: '7px',
                }),
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: '#fbfbfb',
                    border: '1px solid #e8eaed',
                    borderRadius: '5px',
                    boxShadow: '0 1px 3px -2px #9098a9',
                }),
                option: (baseStyles, state) => ({
                    ...baseStyles,
                    cursor: 'pointer',
                }),
                multiValue: (baseStyles, state) => ({
                    ...baseStyles,
                    borderStyle: 'solid',
                    borderWidth: '2px',
                    borderColor: state.data.color,
                    borderRadius: '100px',
                    backgroundColor: '#ffffff',
                    padding: '0',
                    overflow: 'hidden',
                }),
                multiValueLabel: (baseStyles, state) => ({
                    ...baseStyles,
                    padding: '0 3px 0 6px',
                    fontSize: '15px',
                    overflow: 'visible',
                    textOverflow: 'unset',
                    whiteSpace: 'normal',
                }),
                multiValueRemove: (baseStyles, state) => ({
                    ...baseStyles,
                    width: '20px',
                    cursor: 'pointer',
                }),
                menu: (baseStyles, state) => ({
                    ...baseStyles,
                    marginTop: '0',
                }),
            }}
        />
    );

};
